<template>
    <div>
        <div class="order-userInfo" v-if="product.product_id == 1 || product.product_id == 3" >
            <div class="userInfo-wrapper" >
                <div class="userInfo-border" >
                    <h5>基本设置</h5>
                    <el-row class="userInfo-group" >
                        <el-row>
                            <el-col :span="8" class="order-item" >服务时间：<span>{{new Date(product.content.start_at).toLocaleDateString()}}-{{new Date(product.content.end_at).toLocaleDateString()}}</span></el-col>
                        </el-row>
                    </el-row>
                </div>
            </div>
            <div class="userInfo-wrapper" >
                <div class="userInfo-border" >
                    <h5>额度设置</h5>
                    <div class="userInfo-group" >
                        <div class="set-wrapper" >
                            <el-row class="set-number" >
                                <el-col :span="8" class="order-item" >
                                    试题篮数量设置：<span>{{product.content.limit_configure.question_num}}</span>
                                    <span v-html="showOldConfigOther('question_num')"></span>
                                </el-col>
                                <el-col :span="8" class="order-item" >
                                    试题日下载次数：<span>{{product.content.limit_configure.paper_download}}</span>
                                    <span v-html="showOldConfigOther('paper_download')"></span>
                                </el-col>
                                <el-col :span="8" class="order-item" >
                                    下载总次数限制：<span>{{product.content.limit_configure.all_download}}</span>
                                    <span v-html="showOldConfigOther('all_download')"></span>
                                </el-col>
                            </el-row>
                        </div>
                        <el-table
                            :data="product.content.limit_configure.batch"
                            border
                            style="width: 100%">
                            <el-table-column prop="subject_name" label="所有科目">
                            </el-table-column>
                            <el-table-column prop="config.primary" label="小学">
                                <template slot-scope="scope">
                                    {{scope.row.config.primary}}
                                    <span v-html="showOldConfig(scope.row.subject_id,'primary')"></span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="config.middle" label="初中">
                                <template slot-scope="scope">
                                    {{scope.row.config.middle}}
                                    <span v-html="showOldConfig(scope.row.subject_id,'middle')"></span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="config.high" label="高中">
                                <template slot-scope="scope">
                                    {{scope.row.config.high}}
                                    <span v-html="showOldConfig(scope.row.subject_id,'high')"></span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import CustomerService from "~/services/customer";
export default {
    props: {
        product: {
            type: Object
        },
    },
    data(){
        return {
            oldConfig:{}
        }
    },
    created(){
        this.getOrder();
    },
    methods:{
        getOrder() {
            CustomerService.product_config({product_code:this.product.product_code,customer_id:this.product.customer_id}).then(res => {
                this.oldConfig = res.data;
            })
        },
        showOldConfig(subject_id,type){
            if(this.oldConfig && typeof this.oldConfig.batch !='undefined'){
                let item = this.oldConfig.batch.find(i=>{return i.subject_id == subject_id });
                if(!item) return "";
                return "<span  style='color: #f5222d'>原来:"+item.config[type]+"</span>";
            }
            return "";
        },
        showOldConfigOther(need)
        {
            if(typeof this.oldConfig[need] !='undefined'){
                if(this.product.content.limit_configure[need]==this.oldConfig[need]) return "";
                return "<span  style='color: #f5222d'>原来:"+this.oldConfig[need]+"</span>";
            }
            return "";
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/views/order/products/homework.vue